import type * as React from 'react';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { MyNetworkSkeleton } from '@xing-com/crate-network-skeletons';
import { XingletLoader } from '@xing-com/crate-xinglet';

export const Container: React.FC = () => {
  const { isLoggedOut } = useLoginState();

  if (isLoggedOut) {
    return <XingletLoader name="@xing-com/crate-network-entry-logged-out" />;
  }

  return (
    !isLoggedOut && (
      <XingletLoader
        name="@xing-com/crate-network-my-network"
        fallback={<MyNetworkSkeleton />}
      />
    )
  );
};
